import { useCallback } from "react";

interface UseDownloadFileOptions {
  getUrl: () => Promise<string> | string | void;
  filename: string;
  existingUrl?: string | null;
}

/**
 * Hook for downloading files via a link element.
 * Handles reusing an existing URL or fetching a fresh one.
 */
export const useDownloadFile = ({ getUrl, filename, existingUrl }: UseDownloadFileOptions) => {
  return useCallback(async () => {
    try {
      // Reuse existing URL if available, otherwise fetch fresh
      let url: string | null = null;

      if (existingUrl) {
        url = existingUrl;
      } else {
        const result = getUrl();
        url = result instanceof Promise ? await result : result || null;
      }

      if (url) {
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();
      }
    } catch (err) {
      console.error("Failed to download file:", err);
    }
  }, [getUrl, filename, existingUrl]);
};
